export const tourGuideSteps = [
  {
    selector: "#support-event-detail-header",
    content:
      "On the System Event Detail page users can see a summary of the event including the full contents of the label.",
  },
  {
    selector: "#support-event-detail-data-grid",
    content:
      "The system event detail grid allows users to add notes related to this event. Clicking the Update Event button will allow users to add a comment without resolving the event. To resolve the event with a comment, please click Resolve Event.",
  },
];
